const AUTH_QUERY_FLAGS = ['loggedIn', 'loggedOut'] as const

export function currentUrlWithoutAuthFlags(): string {
  const url = new URL(window.location.href)
  AUTH_QUERY_FLAGS.forEach((flag) => url.searchParams.delete(flag))
  return url.toString()
}

export function loggedInRedirectUri(): string {
  const url = new URL(currentUrlWithoutAuthFlags())
  url.searchParams.set('loggedIn', 'true')
  return url.toString()
}

export function loggedOutRedirectUri(): string {
  return `${window.location.origin}/map?loggedOut=true`
}

export function reloginRedirectUri(): string {
  return currentUrlWithoutAuthFlags()
}
